import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '/styles/pstlandingpage.module.scss'
import CustomImage from "../CustomImage"; 
import { Button } from "react-bootstrap";
import router from "next/router";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
    data: any;
    jotformId: any;
    externalLink: any;
}
const PartnerFooter: React.FC<Props> = ({ data, jotformId, externalLink }) => {
     const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <div className={styles.footer} style={{ backgroundColor: data?.sectionTopBgColor || '#F2F2F2' }}>
            <Container>
                <Row className="text-center">
                    <Col>
                        <div className={styles.footerlogo}>
                            <a href="/" target='_blank'> <CustomImage src="/images/educationfair/kc_logo.svg" width={180} height={45} className={styles.navLogo} alt="kclogo" /></a>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div>
                            <p>{data?.footerTitle}</p>
                            <Button onClick={() => {
                                !jotformId && generateLink(externalLink)
                            }}
                                className={`d-none d-sm-block mx-auto ${isFrappeOrJotFormClass(jotformId)}`} >
                                Enquire Now
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default PartnerFooter;